import { c as _c } from "react/compiler-runtime";
import { Prose } from '@/components/Atoms/Prose/Prose';
import { ResponsiveImage } from '@/components/Atoms/ResponsiveImage/ResponsiveImage';
import { ContactFormLink } from '@/components/Molecules/ContactUsFormLink/ContactFormLink';
import { ExpandableDetail } from '@/components/Molecules/ExpandableDetail/ExpandableDetail';
import { ExpandableList } from '@/components/Organisms/ExpandableList/ExpandableList';
import useTranslation from '@/hooks/useTranslation';
import type { IModelDetail } from '@/interfaces';
import { ResponsiveImageHints } from '@/services/ResponsiveImageHints';
import Trans from 'next-translate/Trans';
const imageHints = new ResponsiveImageHints({
  initial: '100vw',
  atL: '60vw',
  atXL: '700px'
}, 1175 / 921);
export const ModelInstructions = t0 => {
  const $ = _c(51);
  const {
    model
  } = t0;
  const {
    t
  } = useTranslation("insights");
  let t1;
  if ($[0] !== model.changeLog || $[1] !== t) {
    t1 = model.changeLog && <ExpandableDetail title={t("insights:ModelInstructions.changeLogTitle")}><Prose $preformatted={true}><p>{model.changeLog}</p></Prose></ExpandableDetail>;
    $[0] = model.changeLog;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("insights:ModelInstructions.loginInstructionsTitle");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("insights:ModelInstructions.loginInstructionsIntro");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("insights:ModelInstructions.loginInstructionsImageAlt");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <ResponsiveImage src="https://assets.bwbx.io/images/users/iIyChnKQ1lHc/iJnFdS_TVSjw/v1/-1x-1.webp" sizeHints={imageHints} alt={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <p>{t3}{t4}{t6}</p>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("insights:ModelInstructions.loginInstructions1");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <li>{t8}</li>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("insights:ModelInstructions.loginInstructions2");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <li>{t10}</li>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li><Trans i18nKey="insights:ModelInstructions.loginInstructions3" components={{
        a: <a href="/account/model-access" />
      }} /></li>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("insights:ModelInstructions.loginInstructions4");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <li>{t13}</li>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14 || $[30] !== t9) {
    t15 = <ol>{t9}{t11}{t12}{t14}</ol>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("insights:ModelInstructions.loginInstructionsTroubleshoot");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = <p><a href="/insights/10574/view">{t16}</a></p>;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("insights:ModelInstructions.loginInstructionsContact");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t18) {
    t19 = <p><ContactFormLink>{t18}</ContactFormLink></p>;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t15 || $[41] !== t17 || $[42] !== t19 || $[43] !== t7) {
    t20 = <Prose>{t7}{t15}{t17}{t19}</Prose>;
    $[40] = t15;
    $[41] = t17;
    $[42] = t19;
    $[43] = t7;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t2 || $[46] !== t20) {
    t21 = <ExpandableDetail title={t2}>{t20}</ExpandableDetail>;
    $[45] = t2;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t1 || $[49] !== t21) {
    t22 = <ExpandableList>{t1}{t21}</ExpandableList>;
    $[48] = t1;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  return t22;
};
interface IProps {
  model: IModelDetail;
}